function rot13(str) {
  var input = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var output = "NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm";

  var index = function index(x) {
    return input.indexOf(x);
  };

  var translate = function translate(x) {
    return index(x) > -1 ? output[index(x)] : x;
  };

  return str.split("").map(translate).join("");
}

module.exports = {
  rot13: rot13
};